/**
 * GeoPST Site JavaScript
 * البوابة الجغرافية لفلسطين
 * 
 * Features:
 * - Theme Toggle (Light/Dark Mode)
 * - Mobile Menu
 * - Smooth Scroll
 * - Header Scroll Effects
 * - Active Navigation
 * - FAQ Accordion
 * - Animations on Scroll
 */ // ═══════════════════════════════════════════════════════════════════════════
// 🌙 THEME TOGGLE — وضع ليلي/نهاري
// ═══════════════════════════════════════════════════════════════════════════
(function initTheme() {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    // Get saved theme or use system preference
    function getTheme() {
        const saved = localStorage.getItem('geopst-theme');
        if (saved) return saved;
        return prefersDark.matches ? 'dark' : 'light';
    }
    // Apply theme to document
    function applyTheme(theme) {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('geopst-theme', theme);
    }
    // Initialize theme immediately
    applyTheme(getTheme());
    // Listen for system theme changes
    prefersDark.addEventListener('change', (e)=>{
        if (!localStorage.getItem('geopst-theme')) applyTheme(e.matches ? 'dark' : 'light');
    });
    // Setup toggle button after DOM is ready
    function setupToggle() {
        const themeToggle = document.getElementById('themeToggle');
        if (themeToggle) {
            // Update aria-label based on current theme
            const currentTheme = document.documentElement.getAttribute('data-theme');
            themeToggle.setAttribute('aria-label', currentTheme === 'dark' ? "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0646\u0647\u0627\u0631\u064A" : "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0644\u064A\u0644\u064A");
            // Toggle theme on button click
            themeToggle.addEventListener('click', ()=>{
                const current = document.documentElement.getAttribute('data-theme');
                const next = current === 'dark' ? 'light' : 'dark';
                // Add transition class for smooth theme change
                document.body.classList.add('theme-transition');
                applyTheme(next);
                // Update aria-label
                themeToggle.setAttribute('aria-label', next === 'dark' ? "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0646\u0647\u0627\u0631\u064A" : "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0644\u064A\u0644\u064A");
                // Remove transition class after animation
                setTimeout(()=>{
                    document.body.classList.remove('theme-transition');
                }, 500);
            });
        // console.log('✅ Theme toggle initialized');
        }
    }
    // Run setup when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupToggle);
    else setupToggle();
})();
// ═══════════════════════════════════════════════════════════════════════════
// 📱 MOBILE MENU — قائمة الموبايل
// ═══════════════════════════════════════════════════════════════════════════
(function initMobileMenu() {
    const toggle = document.getElementById('menuToggle');
    const menu = document.getElementById('mobileMenu');
    if (!toggle || !menu) return;
    function openMenu() {
        menu.classList.add('is-open');
        menu.removeAttribute('hidden');
        toggle.classList.add('active');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
        menu.classList.remove('is-open');
        menu.setAttribute('hidden', '');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
    toggle.addEventListener('click', ()=>{
        const isOpen = menu.classList.contains('is-open');
        isOpen ? closeMenu() : openMenu();
    });
    // Close menu when clicking links
    menu.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', closeMenu);
    });
    // Close menu on escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
    // Close menu on resize to desktop
    window.addEventListener('resize', ()=>{
        if (window.innerWidth >= 1024 && menu.classList.contains('is-open')) closeMenu();
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 📜 HEADER SCROLL EFFECTS — تأثيرات التمرير
// ═══════════════════════════════════════════════════════════════════════════
(function initHeaderScroll() {
    const header = document.querySelector('.header');
    if (!header) return;
    let lastScroll = 0;
    function handleScroll() {
        const currentScroll = window.pageYOffset;
        // Add shadow when scrolled
        if (currentScroll > 10) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
        // Hide header on scroll down, show on scroll up
        if (currentScroll > lastScroll && currentScroll > 200) header.style.transform = 'translateY(-100%)';
        else header.style.transform = 'translateY(0)';
        lastScroll = currentScroll;
    }
    // Throttle scroll handler
    let ticking = false;
    window.addEventListener('scroll', ()=>{
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🔗 ACTIVE NAVIGATION — تمييز الرابط النشط
// ═══════════════════════════════════════════════════════════════════════════
(function initActiveNav() {
    const links = document.querySelectorAll('.nav__link, .mobile__link');
    const path = location.pathname;
    links.forEach((link)=>{
        const href = link.getAttribute('href');
        // Check if link matches current path
        if (path === '/' && (href === '/' || href === '/index.html') || path.includes(href) && href !== '/') {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
        }
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 📅 DYNAMIC YEAR — السنة الديناميكية
// ═══════════════════════════════════════════════════════════════════════════
(function initYear() {
    const yearEl = document.getElementById('year');
    if (yearEl) yearEl.textContent = new Date().getFullYear();
})();
// ═══════════════════════════════════════════════════════════════════════════
// ❓ FAQ ACCORDION — الأسئلة الشائعة
// ═══════════════════════════════════════════════════════════════════════════
(function initFAQ() {
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach((item)=>{
        const question = item.querySelector('.faq-question');
        if (question) question.addEventListener('click', ()=>{
            const isActive = item.classList.contains('active');
            // Close all items
            faqItems.forEach((i)=>i.classList.remove('active'));
            // Open clicked item if it wasn't active
            if (!isActive) item.classList.add('active');
        });
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// ✨ SCROLL ANIMATIONS — تأثيرات الحركة عند التمرير
// ═══════════════════════════════════════════════════════════════════════════
(function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length === 0) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add('animated');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    });
    animatedElements.forEach((el)=>observer.observe(el));
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🔝 SMOOTH SCROLL TO TOP — التمرير السلس للأعلى
// ═══════════════════════════════════════════════════════════════════════════
(function initScrollToTop() {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    if (!scrollTopBtn) return;
    // Show/hide button based on scroll position
    window.addEventListener('scroll', ()=>{
        if (window.pageYOffset > 400) scrollTopBtn.classList.add('visible');
        else scrollTopBtn.classList.remove('visible');
    });
    // Scroll to top on click
    scrollTopBtn.addEventListener('click', ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 📝 CONTACT FORM — نموذج الاتصال
// ═══════════════════════════════════════════════════════════════════════════
(function initContactForm() {
    const form = document.querySelector('.contact-form');
    if (!form) return;
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        // Get form data
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        // Show success message (in production, send to server)
        alert("\u0634\u0643\u0631\u0627\u064B \u0644\u062A\u0648\u0627\u0635\u0644\u0643 \u0645\u0639\u0646\u0627! \u0633\u0646\u0631\u062F \u0639\u0644\u064A\u0643 \u0642\u0631\u064A\u0628\u0627\u064B.");
        form.reset();
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🎯 SMOOTH ANCHOR LINKS — روابط الأنكور السلسة
// ═══════════════════════════════════════════════════════════════════════════
(function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            // Skip if it's just "#"
            if (href === '#') return;
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🖼️ LAZY LOAD IMAGES — تحميل الصور البطيء
// ═══════════════════════════════════════════════════════════════════════════
(function initLazyLoad() {
    const lazyImages = document.querySelectorAll('img[data-src]');
    if (lazyImages.length === 0) return;
    const imageObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.add('loaded');
                imageObserver.unobserve(img);
            }
        });
    });
    lazyImages.forEach((img)=>imageObserver.observe(img));
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🔄 COUNTER ANIMATION — حركة العدادات
// ═══════════════════════════════════════════════════════════════════════════
(function initCounters() {
    const counters = document.querySelectorAll('.stat__num');
    if (counters.length === 0) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const counter = entry.target;
                const target = counter.textContent;
                // Extract number and suffix
                const match = target.match(/^([\d,]+)(.*)$/);
                if (!match) return;
                const finalNum = parseInt(match[1].replace(/,/g, ''));
                const suffix = match[2] || '';
                let current = 0;
                const increment = Math.ceil(finalNum / 50);
                const duration = 1500;
                const stepTime = duration / (finalNum / increment);
                counter.textContent = '0' + suffix;
                const timer = setInterval(()=>{
                    current += increment;
                    if (current >= finalNum) {
                        counter.textContent = target;
                        clearInterval(timer);
                    } else counter.textContent = current.toLocaleString() + suffix;
                }, stepTime);
                observer.unobserve(counter);
            }
        });
    }, {
        threshold: 0.5
    });
    counters.forEach((counter)=>observer.observe(counter));
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🎨 CARD HOVER EFFECTS — تأثيرات البطاقات
// ═══════════════════════════════════════════════════════════════════════════
(function initCardEffects() {
    const cards = document.querySelectorAll('.card, .p-card');
    cards.forEach((card)=>{
        card.addEventListener('mousemove', (e)=>{
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            card.style.setProperty('--mouse-x', `${x}px`);
            card.style.setProperty('--mouse-y', `${y}px`);
        });
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// ⌨️ KEYBOARD NAVIGATION — التنقل بلوحة المفاتيح
// ═══════════════════════════════════════════════════════════════════════════
(function initKeyboardNav() {
    // Focus trap for mobile menu
    const menu = document.getElementById('mobileMenu');
    const toggle = document.getElementById('menuToggle');
    if (!menu || !toggle) return;
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    menu.addEventListener('keydown', (e)=>{
        if (e.key !== 'Tab') return;
        const focusable = menu.querySelectorAll(focusableElements);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });
})();
// ═══════════════════════════════════════════════════════════════════════════
// 🚀 INITIALIZE ON DOM READY
// ═══════════════════════════════════════════════════════════════════════════
document.addEventListener('DOMContentLoaded', ()=>{
    // Add loaded class for CSS transitions
    document.body.classList.add('loaded');
    // Remove loading overlay if exists
    const loader = document.getElementById('pageLoader');
    if (loader) {
        loader.classList.add('hidden');
        setTimeout(()=>loader.remove(), 500);
    }
});
// ═══════════════════════════════════════════════════════════════════════════
// 🔒 DYNAMIC AUTHENTICATION HEADER
// ═══════════════════════════════════════════════════════════════════════════
(function initAuthHeader() {
    const token = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');
    if (!token) return; // Not logged in
    const headerActions = document.querySelector('.header__actions');
    const mobileNav = document.querySelector('.mobile__nav');
    // Inject CSS for the dropdown
    const style = document.createElement('style');
    style.textContent = `
    .user-profile-wrapper { position: relative; margin-right: 15px; }
    .header-user-btn { background: none; border: none; font-size: 1.5rem; color: var(--text-color); cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; transition: all 0.3s; }
    .header-user-btn:hover { background: var(--bg-hover); color: var(--primary); }
    .user-dropdown-glass { position: absolute; top: calc(100% + 10px); left: -100px; width: 220px; background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 12px; padding: 10px; opacity: 0; visibility: hidden; transform: translateY(10px); transition: all 0.3s ease; box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 1000; }
    .user-dropdown-glass.active { opacity: 1; visibility: visible; transform: translateY(0); }
    .user-dropdown-glass .dropdown-header { padding: 10px; display: flex; flex-direction: column; }
    .user-dropdown-glass .dropdown-header span { font-weight: bold; color: var(--text-color); font-size: 0.95rem; }
    .user-dropdown-glass .dropdown-header small { color: var(--text-muted); font-size: 0.8rem; }
    .user-dropdown-glass .dropdown-divider { height: 1px; background: var(--border-color); margin: 5px 0; }
    .user-dropdown-glass .dropdown-item { display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px; border: none; background: none; color: var(--text-color); text-decoration: none; font-size: 0.9rem; cursor: pointer; border-radius: 8px; transition: all 0.2s; text-align: right; font-family: inherit; }
    .user-dropdown-glass .dropdown-item i { width: 20px; text-align: center; }
    .user-dropdown-glass .dropdown-item:hover { background: var(--bg-hover); color: var(--primary); }
    .user-dropdown-glass .logout-text:hover { background: rgba(220,53,69,0.1); color: #dc3545; }
    @media (max-width: 768px) { .user-profile-wrapper { display: none; } }
    
    .mobile-user-actions { display: flex; flex-direction: column; gap: 10px; margin-top: auto; padding-top: 15px; border-top: 1px solid var(--border-color); }
    .mobile-user-actions .dropdown-item { display: flex; align-items: center; gap: 10px; width: 100%; padding: 12px; border: none; background: var(--bg-card); color: var(--text-color); text-decoration: none; font-size: 1rem; cursor: pointer; border-radius: 8px; font-family: inherit; text-align: right; border: 1px solid var(--border-color); }
    .mobile-user-actions .dropdown-item i { font-size: 1.1rem; width: 24px; text-align: center; }
  `;
    document.head.appendChild(style);
    // Inject fontawesome if not present
    if (!document.querySelector('link[href*="font-awesome"]')) {
        const fa = document.createElement('link');
        fa.rel = 'stylesheet';
        fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
        document.head.appendChild(fa);
    }
    // Parse JWT
    const parseJwt = (t)=>{
        try {
            return JSON.parse(atob(t.split('.')[1]));
        } catch (e) {
            return null;
        }
    };
    const decoded = parseJwt(token);
    const userName = decoded ? decoded.name || decoded.email.split('@')[0] : "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645";
    if (headerActions) {
        const mapBtn = headerActions.querySelector('.btn--primary');
        if (mapBtn) {
            mapBtn.innerHTML = '<i class="fas fa-map-marked-alt" style="margin-left: 5px;"></i> \u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u0644\u062E\u0631\u064A\u0637\u0629';
            const profileHtml = '<div class="user-profile-wrapper" id="siteUserProfileWrapper"><button id="siteUserProfileBtn" class="header-user-btn" title="\u062D\u0633\u0627\u0628\u064A"><i class="fas fa-user-circle"></i></button><div id="siteUserDropdown" class="user-dropdown-glass"><div class="dropdown-header"><span>' + userName + '</span><small>\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628</small></div><div class="dropdown-divider"></div><a href="/account-settings.html" class="dropdown-item"><i class="fas fa-unlock-alt"></i> <span style="flex:1;">\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631</span></a><div class="dropdown-divider"></div><button onclick="siteLogout()" class="dropdown-item logout-text"><i class="fas fa-sign-out-alt"></i> <span style="flex:1;">\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C</span></button></div></div>';
            mapBtn.insertAdjacentHTML('beforebegin', profileHtml);
            const btn = document.getElementById('siteUserProfileBtn');
            const dropdown = document.getElementById('siteUserDropdown');
            btn.addEventListener('click', (e)=>{
                e.stopPropagation();
                dropdown.classList.toggle('active');
            });
            document.addEventListener('click', (e)=>{
                if (!e.target.closest('#siteUserProfileWrapper') && dropdown) dropdown.classList.remove('active');
            });
        }
    }
    if (mobileNav) {
        const mobileMapBtn = mobileNav.querySelector('.mobile__cta');
        if (mobileMapBtn) {
            mobileMapBtn.innerHTML = '<i class="fas fa-map-marked-alt" style="margin-left: 5px;"></i> \u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u0644\u062E\u0631\u064A\u0637\u0629';
            const mobileHtml = '<div class="mobile-user-actions"><div style="padding: 0 10px 10px; color: var(--text-color); font-weight: bold;"><i class="fas fa-user-circle"></i> \u0645\u0631\u062D\u0628\u0627\u064B\u060C ' + userName + '</div><a href="/account-settings.html" class="dropdown-item"><i class="fas fa-unlock-alt"></i> <span>\u062A\u063A\u064A\u064A\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631</span></a><button onclick="siteLogout()" class="dropdown-item logout-text" style="color: #dc3545; border-color: rgba(220,53,69,0.3);"><i class="fas fa-sign-out-alt"></i> <span>\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C</span></button></div>';
            mobileNav.insertAdjacentHTML('beforeend', mobileHtml);
        }
    }
    window.siteLogout = function() {
        localStorage.removeItem('map_token');
        sessionStorage.removeItem('map_token');
        window.location.href = '/';
    };
})(); // console.log('🌍 GeoPST Site initialized successfully!');

//# sourceMappingURL=client.39548002.js.map
